import { render, staticRenderFns } from "./confirmDeletionFormMobileModal.vue?vue&type=template&id=4565f242&"
import script from "./confirmDeletionFormMobileModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionFormMobileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports